<template>
  <div class="contenter">
    <div class="main-con">
      <el-col class="menu-space">
        <div class="creat-btn-space">
          <el-button
            v-permission="'creat_role'"
            type="primary"
            icon="el-icon-plus"
            @click="createNewRole"
            class="creat-btn"
            >创建角色
          </el-button>
        </div>
        <div class="left-menu">
          <el-menu
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            active-text-color="#165DFF"
            default-active="1-1"
            :default-openeds="defaultOpeneds"
          >
            <el-submenu index="1">
              <template slot="title">
                <!-- <i class="el-icon-location"></i> -->
                <img
                  src="@/assets/images/user@2x.png"
                  alt=""
                  class="menu-icon"
                />
                <span>默认角色</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :index="`1-${index + 1}`"
                  v-for="(item, index) in defaultRoleList"
                  :key="index"
                  @click="handleMenuClick(item, 1)"
                  >{{ item.name }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <!-- <i class="el-icon-menu"></i> -->
                <img src="@/assets/images/user@2x.png" class="menu-icon" />
                <span>自定义角色</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :index="`1-${index + 8}`"
                  v-for="(item, index) in customRoleList"
                  :key="index"
                  @click="handleMenuClick(item, 2)"
                  >{{ item.name }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </el-col>
      <el-col class="role-space" v-if="!creatRole">
        <div class="role-info">
          <div class="role-infoL">
            <div class="role-icon">
              <img src="@/assets/images/user_white@2x.png" />
            </div>
            <div class="role-name">
              <div class="role-nameT">{{ clickedRoleInfo.name }}</div>
              <div class="role-nameB">{{ clickedRoleInfo.description }}</div>
            </div>
          </div>
          <div class="role-infoR">
            <div
              v-permission="'edit_role'"
              class="role-edit"
              @click="editCurRole"
            >
              <img src="@/assets/images/edit@2x.png" />
              <span>修改</span>
            </div>
            <div
              v-permission="'del_role'"
              class="role-edit role-del"
              v-if="isDefaultRole === 2"
              @click="delRole"
            >
              <img src="@/assets/images/delete@2x.png" />
              <span>删除</span>
            </div>
            <div
              v-permission="'del_role'"
              v-else
              class="role-edit role-del unavailable"
            >
              <img src="@/assets/images/delete@2x(1).png" />
              <span>删除</span>
            </div>
          </div>
        </div>
        <div class="role-edit-connter">
          <div class="tab-title">
            <div
              class="tab-title-item"
              :class="{ 'item-active': itemActive === 1 }"
              @click="tabChange(1)"
            >
              分配用户
            </div>
            <div
              class="tab-title-item"
              :class="{ 'item-active': itemActive === 2 }"
              @click="tabChange(2)"
            >
              角色权限
            </div>
          </div>
          <div class="tab-space">
            <div class="role-table-space" v-if="itemActive === 1">
              <roleTable :accountList="accountList"></roleTable>
              <div class="page">
                <el-pagination
                  layout="->,total,prev, pager, next"
                  @current-change="currentChangefn"
                  :total="total"
                  :page-size="size"
                  :current-page="page"
                >
                </el-pagination>
              </div>
            </div>
            <div class="role-per" v-if="itemActive === 2">
              <selectTree
                :treeData="treeData"
                :checkedKeys="checkedKeys"
                :clickedRoleInfo="clickedRoleInfo"
                :isShowSave="isShowSave"
                @consoleEdit="consoleEdit"
                @getCheckedKeys="getCheckedKeys"
              ></selectTree>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="role-space" v-else>
        <el-form
          :model="searchForm"
          size="mini"
          :inline="true"
          label-width="90px"
          :rules="rules"
        >
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              clearable
              size="mini"
              v-model="searchForm.roleName"
              placeholder="请输入角色名称"
              style="width: 25vw"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input
              clearable
              size="mini"
              v-model="searchForm.desc"
              placeholder="请输入描述"
              style="width: 25vw"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div class="select-tree-space">
          <selectTree
            :treeData="treeData"
            :checkedKeys="checkedKeys"
            :clickedRoleInfo="clickedRoleInfo"
            :searchForm="searchForm"
            :isCreatRole="true"
            :isShowSave="true"
            @getCheckedKeys="getCheckedKeys"
          ></selectTree>
        </div>
      </el-col>
    </div>
    <div class="btn-space" v-if="isShowSave && itemActive === 2">
      <el-button class="con-btn" @click="consoleEdit"> 取消 </el-button>
      <el-button type="primary" @click="saveRolePermission"> 保存 </el-button>
    </div>
    <conDialog
      contentText="你确定要删除该角色吗"
      :isShow="centerDialogVisible"
      title="提示"
      @conform="confirmDelRole"
      @cancel="centerDialogVisible = false"
    ></conDialog>
  </div>
</template>

<script>
import roleTable from "./components/roleTable.vue";
import selectTree from "./components/selectTree.vue";
import conDialog from "@/components/dialog.vue";
export default {
  name: "roleManage",
  components: {
    roleTable,
    selectTree,
    conDialog,
  },
  data() {
    return {
      roleList: [],
      treeData: [],
      checkedKeys: [],
      checkedKey: [],
      clickedRoleInfo: {},
      itemActive: 1,
      accountList: [],
      total: 0,
      size: 10,
      page: 1,
      roleId: "",
      defaultOpeneds: ["1"],
      isDefaultRole: 1,
      defaultProps: {
        children: "children",
        label: "name",
      },
      searchForm: {
        roleName: "",
        desc: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        desc: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
      creatRole: false,
      centerDialogVisible: false,
      isShowSave: false,
    };
  },
  computed: {
    defaultRoleList() {
      return this.roleList.filter((item) => item.type === 1);
    },
    customRoleList() {
      return this.roleList.filter((item) => item.type === 0);
    },
  },
  beforeMount() {
    this.treeData = [...this.projectConfig.LEFT_MENU];
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    getCheckedKeys(checkedKeys) {
      // console.log("父组件checkedKeys", checkedKeys);
      this.checkedKey = checkedKeys;
    },
    createNewRole() {
      this.creatRole = true;
      this.isShowSave = true;
      this.itemActive = 2;
      this.checkedKeys = [];
      this.checkedKey = [];
      this.searchForm.roleName = "";
      this.searchForm.desc = "";
      let treeData = [...this.treeData];

      const markSelected = (items) => {
        for (let it of items) {
          this.$set(it, "disabled", false);
          if (it.children) {
            markSelected(it.children);
          }
        }
      };
      markSelected(treeData);
    },
    consoleEdit(val) {
      this.isShowSave = false;
      this.handleMenuClick(this.clickedRoleInfo, this.isDefaultRole, true);
    },
    editCurRole() {
      this.itemActive = 2;

      if (this.clickedRoleInfo.code == "super_administrator") {
        this.$message({
          type: "error",
          message: "超级管理员不能修改角色权限",
        });
        return;
      }
      // console.log("editCurRole执行了", this.clickedRoleInfo);
      this.handleMenuClick(this.clickedRoleInfo, this.isDefaultRole, false);
      this.isShowSave = true;
    },
    delRole() {
      this.centerDialogVisible = true;
    },
    confirmDelRole() {
      this.centerDialogVisible = false;
      this.$get("/user/removeRole", {
        id: this.clickedRoleInfo.id,
      }).then((res) => {
        const data = res.data;
        if (data.code === 1000) {
          this.$message({
            type: "success",
            message: data.msg,
          });
          this.getRoleList();
        } else {
          this.$message({
            type: "error",
            message: data.msg,
          });
        }
      });
    },
    currentChangefn(index) {
      this.page = index;
      this.getAccountList();
    },
    getAccountList() {
      //user/roleList
      this.$get("/user/admin/list", {
        page: this.page,
        size: 10,
        roleId: this.roleId,
      }).then((res) => {
        // console.log("账号列表", res);
        if (res.data.code === 1000) {
          this.total = res.data.data.count;
          this.accountList = res.data.data.list;
          // console.log("this.accountList", this.accountList);
        }
      });
    },
    tabChange(val) {
      this.itemActive = val;
      this.handleMenuClick(this.clickedRoleInfo, this.isDefaultRole);
    },
    saveRolePermission() {
      // console.log("this.searchForm", this.searchForm);

      let treeData = [...this.treeData];
      const checkedKeys = this.checkedKey;

      const markSelected = (items) => {
        for (let item of items) {
          item.selected = checkedKeys.includes(item.code);
          if (item.children) {
            markSelected(item.children);
          }
        }
      };

      markSelected(treeData);
      // return;
      if (this.creatRole) {
        if (!this.searchForm.roleName) {
          this.$message({
            type: "error",
            message: "请输入角色名称",
          });
          return;
        } else if (!this.searchForm.desc) {
          this.$message({
            type: "error",
            message: "请输入角色描述",
          });
          return;
        }
        // if (checkedKeys.length === 0) {//未选择角色的时候拦截
        //   this.$message({
        //     type: "error",
        //     message: "请选择角色权限",
        //   });
        //   return;
        // }
        this.creatRoleFn(treeData);
      } else {
        this.editRoleFn(treeData);
      }
    },
    creatRoleFn(treeData) {
      let params = {
        description: this.searchForm.desc,
        // id: this.searchForm.id,
        name: this.searchForm.roleName,
        permissions: treeData,
      };
      this.$post("/user/addRole", params).then((res) => {
        // console.log("创建角色", res);
        this.afterPost(res);
      });
    },
    editRoleFn(treeData) {
      let params = {
        description:
          this.clickedRoleInfo.description || this.clickedRoleInfo.name,
        id: this.clickedRoleInfo.id,
        name: this.clickedRoleInfo.name,
        permissions: treeData,
      };
      this.$post("/user/editRole", params).then((res) => {
        // console.log("编辑角色权限", res);
        this.afterPost(res);
      });
    },
    afterPost(res) {
      const data = res.data;
      if (data.code === 1000) {
        this.isShowSave = false;
        this.$message({
          type: "success",
          message: data.msg,
        });
        this.getRoleList();
      } else {
        this.$message({
          type: "error",
          message: data.msg,
        });
      }
    },
    handleMenuClick(item, index, isAbled = true) {
      // console.log("handleMenuClick", item);
      this.isShowSave = false;
      let treeData = [...this.treeData];
      this.creatRole = false;
      this.isDefaultRole = index;
      // console.log("this.defaultOpeneds", this.defaultOpeneds);

      this.clickedRoleInfo = item;
      this.checkedKeys = [];
      if (item.name === "超级管理员") {
        const markSelected = (items) => {
          for (let it of items) {
            this.$set(it, "disabled", isAbled);
            this.checkedKeys.push(it.code);
            if (it.children) {
              markSelected(it.children);
            }
          }
        };
        markSelected(treeData);
      } else {
        // console.log("item.permissions", item.permissions);
        const markSelected = (items) => {
          for (let it of items) {
            this.$set(it, "disabled", isAbled);
            if (it.children) {
              markSelected(it.children);
            }
          }
        };
        markSelected(treeData);
        if (item.permissions) {
          // this.$refs.tree.setCheckedKeys(item.permissions);
          this.checkedKeys = item.permissions;
        } else {
          this.checkedKeys = [];
          // this.$refs.tree.setCheckedKeys([]);
        }
      }
      this.roleId = item.id;
      this.getAccountList();
      // console.log("this.checkedKeys==", this.checkedKeys);
    },
    checkChange(node, checked) {
      // console.log("checkChange", node, checked);
    },
    check(val, val1) {
      this.checkedKeys = val1.checkedKeys;
    },
    handleOpen(index) {
      // console.log(index);
      // console.log("this.defaultOpeneds==++", this.defaultOpeneds);
      // this.defaultOpeneds.push(`${index}`);
    },
    handleClose(index) {
      // console.log("this.defaultOpeneds==", this.defaultOpeneds);
      // this.defaultOpeneds = this.defaultOpeneds.filter((item) => item !== `${index}`);
    },
    editRole(permission) {
      // console.log("clickedRoleInfo", this.clickedRoleInfo);
      let params = {
        description: this.clickedRoleInfo.description,
        id: this.clickedRoleInfo.id,
        name: this.clickedRoleInfo.name,
        permissions: permission,
      };
      this.$post("/user/editRole", {
        ...params,
      }).then((res) => {
        // console.log("编辑角色权限", res);
      });
    },
    getRoleList() {
      this.$get("/user/roleList", {
        permissions: true,
      }).then((res) => {
        // console.log("角色列表", res.data.data);
        let roleList = res.data.data.list;
        this.roleList = roleList;
        if (this.roleList[0]?.id) {
          // console.log("roleList==", roleList);
          // console.log("this.clickedRoleInfo==1", this.clickedRoleInfo);
          if (!this.clickedRoleInfo?.id) {
            this.clickedRoleInfo = roleList[0];
          }
          // console.log("this.clickedRoleInfo==", this.clickedRoleInfo);

          this.roleId = this.roleList[0]?.id;
          this.getAccountList();
          this.handleMenuClick(this.clickedRoleInfo, this.isDefaultRole, true);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.el-menu {
  border-right: none;
}
.main-con {
  display: flex;
  padding-left: 8px;
  height: 100%;
}
.contenter {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 0px 0px 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  // overflow-y: auto; /* 启用垂直滚动 */
  overflow: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  /* 针对 Webkit 浏览器 */
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
}
.btn-space {
  position: sticky;
  background-color: #fff;
  width: 100%;
  height: 56px;
  bottom: 0px;
  z-index: 2000;
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  .el-button {
    border-radius: 2px;
    font-size: 14px;
    width: 60px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
  }
  .con-btn {
    background-color: #f2f3f5;
    color: #4e5969;
  }
}
.menu-space {
  box-sizing: border-box;
  width: 220px;
  // height: calc(100% - 100px);
  height: 100%;
  overflow: hidden;
}
.left-menu {
  overflow: auto;
  height: (100% - 15px);
  // height: 100%;
}
.role-space {
  flex: 1;
  padding-left: 17px;
  padding-right: 20px;
  height: 100%;
  overflow: hidden;
}
.role-edit-connter {
  display: flex;
  flex-direction: column;
  height: 100%;
}
::v-deep .el-tree-node__content {
  font-size: 14px;
  color: #1d2129;
}
.role-info {
  width: 100%;
  background-color: #e8f3ff;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .role-infoL {
    display: flex;
    align-items: center;
    .role-icon {
      width: 62px;
      height: 62px;
      background-color: #4080ff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 17px;
      img {
        width: 31px;
        height: 31px;
      }
    }
    .role-name {
      .role-nameT {
        font-weight: 500;
        font-size: 16px;
        color: #165dff;
        margin-bottom: 4px;
      }
      .role-nameB {
        font-weight: 400;
        font-size: 14px;
        color: rgba(29, 33, 41, 1);
      }
    }
  }
  .role-infoR {
    display: flex;
    .role-edit {
      cursor: pointer;
      background-color: #165dff;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 82px;
      height: 32px;
      border-radius: 2px;
      color: #fff;
      font-size: 14px;
      img {
        width: 14px;
        margin-right: 4px;
      }
    }
    .role-del {
      background-color: #fff;
      color: #4e5969;
      margin-left: 8px;
    }
  }
}
.role-edit-connter {
}
.tab-space {
  display: flex;
  height: calc(100% - 170px);
  overflow: auto;
}
.role-table-space {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.role-per {
  padding: 20px 0 50px 25px;
}
.menu-icon {
  width: 18px;
  height: 18px;
  margin-right: 16px;
}
.creat-btn-space {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
  .creat-btn {
    width: 110px;
    height: 32px;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
  }
}
.el-menu .el-menu-item.is-active {
  background-color: #f2f3f5;
}
.el-menu .el-menu-item {
  font-weight: 500;
}
.el-menu .el-menu-item:hover {
  background-color: #f2f3f5;
}
.tab-title {
  display: flex;
  width: 188px;
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  .tab-title-item {
    width: 88px;
    height: 32px;
    font-weight: 400;
    font-size: 14px;
    color: #4e5969;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .item-active {
    background: #f2f3f5;
    border-radius: 100px;
    color: #165dff;
  }
}
.unavailable {
  color: #c9cdd4 !important;
  cursor: not-allowed !important;
}
.select-tree-space {
  height: calc(100% - 165px);
  display: flex;
  padding: 10px 0 50px 70px;
  overflow: auto;
}
</style>
